import { render, staticRenderFns } from "./TypeWordPronunciation.vue?vue&type=template&id=ffcff84a&"
import script from "./TypeWordPronunciation.vue?vue&type=script&lang=js&"
export * from "./TypeWordPronunciation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports